import { ReactComponent as TranslationIconSvg } from './translation-icon.svg'
export default TranslationIconSvg
